import React from 'react';
import { Linkedin, Instagram, Youtube, Facebook } from 'lucide-react';
import { TikTokIcon } from '@/components/ui/TikTokIcon';
import type { Channel } from '@/services/business/calendar';

const SIZE_MAP = {
  xs: 'w-3 h-3',
  sm: 'w-3.5 h-3.5',
  md: 'w-4 h-4',
  lg: 'w-5 h-5',
} as const;

export type ChannelIconSize = keyof typeof SIZE_MAP;

export function getChannelIconElement(
  channel: Channel,
  size: ChannelIconSize = 'sm',
): React.ReactElement {
  const cls = SIZE_MAP[size];

  switch (channel) {
    case 'linkedin':
      return <Linkedin className={cls} />;
    case 'instagram':
      return <Instagram className={cls} />;
    case 'tiktok':
      return <TikTokIcon className={cls} />;
    case 'youtube':
      return <Youtube className={cls} />;
    case 'facebook':
      return <Facebook className={cls} />;
  }
}
